import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';
// -------------------------------------------------------

class Projects extends React.Component {
  setFavorite(project_id, is_favorite, e) {
    e.preventDefault();
    document.activeElement.blur();
    
    // データ通信
    Utils.request.bind(this)('/api/dashboard/projects-favorite', { project_id: project_id, is_favorite: !(is_favorite === true) },
      function(res){
        this.props.data.event.updateData.bind(this)(res.body.data);
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    
    let module_class = (this.props.is_home === true) ? 'home' : '';
    
    return (
      <ul className={'module '+ module_class}>
        { this.props.projects.map((d, key) => {
          let flg = (d.is_favorite == true) ? 'on' : 'off';
          return (
            <a key={key} href={'/project/'+ d.unique_code}>
              <li>
                <div className="thumbnail">
                  { (d.thumbnail == null)
                    ? <div className="not-image" />
                    : <img src={d.thumbnail} />
                  }
                </div>
                <p className="title">{d.title}</p>
                
                <i className={'material-icons fav '+ flg} onClick={this.setFavorite.bind(this, d.id, d.is_favorite)}>star</i>
              </li>
            </a>
          );
        })}
        
        { (data.userData && data.userData.is_guest == 0)
          && <a href="project-create" target="_blank"><li className="project-create"><i className="material-icons">add_circle_outline</i>プロジェクトの作成</li></a>
        }
      </ul>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default Projects;